import { connect } from "react-redux";
import { RootState } from "../../reducers";
import { TowToLockoutTriage as Component, TowToLockoutTriageProps } from "./TowToLockoutTriage.component";
import { getCommonBenefits, getDisplayCode, getServiceInfo } from "../../selector";
import {
  clearCCardInfo,
  clearPreviousBenefits,
  commonBenefitsSuccess,
  noCommonBenefitsWithPrevious,
  updateCCardInfo,
  updateCurrentLocation,
  updateLoggedInFlag,
  updatePpuFlag,
  updateTowReason,
} from "../../action";

const mapStateToProps = (state: RootState) =>
  ({
    commonBenefits: getCommonBenefits(state),
    displayCode: getDisplayCode(state),
    serviceInfo: getServiceInfo(state),
  } as Pick<TowToLockoutTriageProps, "commonBenefits" | "displayCode" | "serviceInfo">);

const mapDispatchToProps = {
  clearCCardInfo,
  clearPreviousBenefits,
  commonBenefitsSuccess,
  noCommonBenefitsWithPrevious,
  updateCCardInfo,
  updateCurrentLocation,
  updateLoggedInFlag,
  updatePpuFlag,
  updateTowReason,
} as Pick<
  TowToLockoutTriageProps,
  | "clearCCardInfo"
  | "clearPreviousBenefits"
  | "commonBenefitsSuccess"
  | "noCommonBenefitsWithPrevious"
  | "updateCCardInfo"
  | "updateCurrentLocation"
  | "updatePpuFlag"
  | "updateLoggedInFlag"
  | "updateTowReason"
>;

export const TowToLockoutTriage = connect(mapStateToProps, mapDispatchToProps)(Component);
